export default __webpack_public_path__ + "static/media/about2.1c90f6b0.jpg";